import {
	Checkbox,
	FormControlLabel,
	FormLabel,
	List,
	ListItem,
	ListItemText,
	Paper,
	Radio,
	TextField,
} from "@material-ui/core";
import { Formik } from "formik";
import React, { useCallback } from "react";
import userReservationStyles from "../../../../assests/styles/views/public/userReservation";
import ButtonWithLoading from "../../../../components/ButtonWithLoading";
import { getTranslation } from "../../../../heplers/translationHelper";
import * as Yup from "yup";
import { Post_Reservation_URL } from "../../../../constants/apiUrls";
import { useSnackbar } from "notistack";
import moment from "moment";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Autocomplete } from "@material-ui/lab";
import { Get } from "../../../../actions";
import { debounce } from "lodash";

const PersonalInfoForm = ({
	selectedReservation,
	setSelectedReservation,
	addReservation,
	setActiveStep,
	showSuccessMsg,
	setShowSuccessMsg,
	classes,
}) => {
	// const classes = userReservationStyles();
	const params = useParams();
	let { primaryColor, secondaryColor } = params;
	if (typeof primaryColor === "undefined") primaryColor = "E7424C";
	if (typeof secondaryColor === "undefined") secondaryColor = "ffffff";
	const { enqueueSnackbar } = useSnackbar();
	const { isAdmin } = useSelector((state) => state.userReservation);
	const [filtered, setFiltered] = useState([]);
	const [highlightIndex, setHighlightIndex] = useState(-1);
	const validationSchema = isAdmin ? Yup.object().shape({
		fullName: Yup.string().required(getTranslation("Full name is required"))
	}) :

		Yup.object().shape({
			fullName: Yup.string().required(getTranslation("Full name is required")),
			email: Yup.string()
				.email(getTranslation("Please enter a valid email address"))
				.required(getTranslation("Email is required")),
			phone: Yup.string().required(getTranslation("Phone number is required")),
			// allergies: Yup.string(),
			//haveSmallKids: Yup.boolean(),
			acceptTerms: Yup.boolean().required(getTranslation("Accept terms is required to proceed")),
		});




	const onSubmit = (values, actions) => {
		if (values.haveSmallKids && values.kids < 1) {
			actions.setSubmitting(false);
			enqueueSnackbar(
				getTranslation(
					"Minimum 1 kid required",
					"Minimum 1 kid required",
					"Minimum 1 kid required"
				),
				{
					variant: "error",
				}
			);
			return;
		}

		const data = { ...selectedReservation, ...values };

		setSelectedReservation(data);
		const { title, acceptTerms, startTime, ...rest } = data;

		const payload = {
			isAdmin: isAdmin,
			allergies: rest.allergies,
			haveSmallKids: rest.haveSmallKids,
			kids: rest.kids,
			persons: rest.persons,
			timeSlotId: rest.timeSlotId,
			timeSlot: rest.timeSlots,
			maxCapacityId: rest.maxCapacityId,
			areaId: rest.areaId,
			reservationDate: data.reservationDate,
			purposeOfReservation: data.purposeOfReservation,
			customer: {
				fullName: rest.fullName,
				email: rest.email,
				phone: rest.phone,
				subscribeForNews: rest.subscribeForNews,
			},
			primaryColor: primaryColor,
			secondaryColor: secondaryColor,
			status: 0,
		};
		addReservation(payload, Post_Reservation_URL, actions);
	};

	const handleBack = (val) => {
		const modifiedValue = { ...val, title: val.fullName };
		const data = { ...selectedReservation, ...modifiedValue };
		setSelectedReservation(data);
		setActiveStep(0);
	};

	const [suggestionsData,setSuggestionsData] =useState([]);

	const handleInputChange = (e, handleChange) => {
		handleChange(e);
		const value = e.target.value;

		if (value) {
			const results = suggestionsData.filter((item) =>
				item.toLowerCase().includes(value.toLowerCase())
			);
			setFiltered(results);
		} else {
			setFiltered([]);
		}

		setHighlightIndex(-1);
	};

	const handleKeyDown = (e) => {
		if (!filtered.length) return;

		if (e.key === "ArrowDown") {
			e.preventDefault();
			setHighlightIndex((prev) =>
				prev < filtered.length - 1 ? prev + 1 : prev
			);
		}

		if (e.key === "ArrowUp") {
			e.preventDefault();
			setHighlightIndex((prev) => (prev > 0 ? prev - 1 : 0));
		}

		if (e.key === "Enter" && highlightIndex >= 0) {
			e.preventDefault();
			selectItem(filtered[highlightIndex]);
		}
	};

	const selectItem = (value, handleChange) => {
		console.log("kjagdjsakhdsakjd", value)
		handleChange({
			target: { name: "fullName", value },
		});
		setFiltered([]);
		setHighlightIndex(-1);
	};

const searchCustomers = useCallback(
  debounce((search) => {
    Get(
      { searchString: search, pageNumber: 0, pageSize: 10 },
      "Customer/GetAllCustomersWithPagination",
      null,
      (resp) => {
        console.log("kjahdkjahdkjahdasd", resp);
        setSuggestionsData(resp.data.items);
      },
      (error) => {}
    );
  }, 500), // 500ms delay
  []
);

	return (
		<div>
			<Formik
				validationSchema={validationSchema}
				initialValues={{
					...selectedReservation,
					fullName: selectedReservation.title,
				}}
				onSubmit={onSubmit}
				validateOnChange={false}
			>
				{({
					values,
					setFieldValue,
					errors,
					touched,
					handleChange,
					handleSubmit,
					isSubmitting,
				}) => (
					<form onSubmit={handleSubmit}>
						<div className={classes.inputConts}>
							<Autocomplete
  freeSolo
  options={suggestionsData}
  getOptionLabel={(option) =>
    typeof option === "string" ? option : option.fullName || ""
  }

  // ✅ selected object
  value={
    suggestionsData.find((opt) => opt.fullName === values.fullName) || null
  }

  // ✅ typed text (IMPORTANT)
  inputValue={values.fullName || ""}

  onInputChange={(event, newInputValue) => {
    // typing
    setFieldValue("fullName", newInputValue);

    if (newInputValue && isAdmin) {
      searchCustomers(newInputValue);
    }
  }}

  onChange={(event, newValue) => {
    // selection from dropdown
    if (typeof newValue === "string") {
      setFieldValue("fullName", newValue);
    } else {
      setFieldValue("fullName", newValue?.fullName || "");
      setFieldValue("phone", newValue?.phone || "");
      setFieldValue("email", newValue?.email || "");
    }
  }}

  renderOption={(option) => (
    <div>
      <div>{option.fullName}</div>
      <small>{option.phone}</small>
    </div>
  )}

  renderInput={(params) => (
    <TextField
      {...params}
      variant="outlined"
      required
      fullWidth
      label={getTranslation("Full Name")}
      size="small"
      error={touched.fullName && Boolean(errors.fullName)}
      helperText={touched.fullName && errors.fullName}
      autoComplete="off"
    />
  )}
/>
<TextField
								variant="outlined"
								required
								fullWidth
								label={getTranslation("Email", "Email", "Email")}
								name="email"
								type="string"
								size="small"
								value={values.email}
								onChange={handleChange}
								error={touched.email && Boolean(errors.email)}
								helperText={touched.email && errors.email}
							/>
						</div>
						<TextField
							className={classes.input}
							variant="outlined"
							required
							fullWidth
							label={getTranslation(
								"Phone Number",
								"Phone Number",
								"Phone Number"
							)}
							name="phone"
							type="text"
							size="small"
							value={values.phone}
							onChange={handleChange}
							error={touched.phone && Boolean(errors.phone)}
							helperText={touched.phone && errors.phone}
						/>
						<TextField
							className={classes.input}
							variant="outlined"
							multiline
							minRows={2}
							fullWidth
							inputProps={{ maxLength: 100 }}
							label={getTranslation(
								"Give information of allergies and Intolerance",
								"Give information of allergies and Intolerance",
								"Give information of allergies and Intolerance"
							)}
							name="allergies"
							type="number"
							size="small"
							value={values.allergies}
							onChange={handleChange}
							error={touched.allergies && Boolean(errors.allergies)}
							helperText={
								(touched.allergies && errors.allergies) ||
								`${(values.allergies || "").length}/100`
							}
						/>
						<div>
							<FormControlLabel
								label={getTranslation(
									"Select if there will be kids < 4 years old",
									"Select if there will be kids < 4 years old",
									"Select if there will be kids < 4 years old"
								)}
								name="haveSmallKids"
								value={values.haveSmallKids}
								onChange={(val) => {
									const { checked } = val.target;
									setFieldValue("haveSmallKids", checked);
									if (checked == false) {
										setFieldValue("kids", 0);
									}
								}}
								control={
									<Checkbox
										checked={values.haveSmallKids}
										// className={classes.checkBox}
										style={{ color: "#" + primaryColor }}
									/>
								}
							/>
						</div>
						{values.haveSmallKids && (
							<TextField
								variant="outlined"
								required={!isAdmin}
								fullWidth
								label={getTranslation(
									"Number of Kids",
									"Number of Kids",
									"Number of Kids"
								)}
								name="kids"
								type="number"
								size="small"
								value={values.kids}
								onChange={handleChange}
								error={touched.kids && Boolean(errors.kids)}
								helperText={touched.kids && errors.kids}
								InputProps={{ inputProps: { min: 1 } }}
							/>
						)}
						<div>
							<FormControlLabel
								label={getTranslation(
									"Accept Terms & Conditions",
									"Accept Terms & Conditions",
									"Accept Terms & Conditions"
								)}
								name="acceptTerms"
								value={values.acceptTerms}
								onChange={(val) => {
									const { checked } = val.target;
									setFieldValue("acceptTerms", checked);
								}}
								control={
									<Checkbox
										checked={values.acceptTerms}
										style={{ color: "#" + primaryColor }}
									/>
								}
							/>
							{touched.acceptTerms && errors.acceptTerms ? (
								<div>{errors.acceptTerms}</div>
							) : null}
						</div>
						<div>
							<FormControlLabel
								label={getTranslation(
									"Subscribe for Newsletter",
									"Subscribe for Newsletter",
									"Subscribe for Newsletter"
								)}
								value={values.subscribeForNews}
								name="subscribeForNews"
								onChange={(val) => {
									const { checked } = val.target;
									setFieldValue("subscribeForNews", checked);
								}}
								control={
									<Checkbox
										checked={values.subscribeForNews}
										style={{ color: "#" + primaryColor }}
									/>
								}
							/>
						</div>
						<div className={classes.btnWrapper}>
							<ButtonWithLoading
								className={classes.submitBtn}
								type="button"
								onClick={() => handleBack(values)}
								title={getTranslation("Back", "Back", "Back")}
								variant="contained"
								style={{
									//backgroundColor:"#"+primaryColor,
									color: "black",
								}}
							/>
							<ButtonWithLoading
								type="submit"
								disabled={!values.acceptTerms}
								onClick={handleSubmit}
								title={getTranslation("Submit", "Submit", "Submit")}
								variant="contained"
								loading={isSubmitting}
								// color={"primary"}
								style={
									values.acceptTerms == false
										? {
											marginLeft: "50px",
										}
										: isSubmitting == false
											? {
												marginLeft: "50px",
												backgroundColor: "#" + primaryColor,
												color: "#" + secondaryColor,
											}
											: {
												marginLeft: "50px",
												backgroundColor: "gray",
												color: "#" + primaryColor,
											}
								}
							/>
						</div>
					</form>
				)}
			</Formik>
		</div>
	);
};

export default PersonalInfoForm;
